export default __webpack_public_path__ + "static/media/box.3af81a3a.png";